module.exports = __webpack_public_path__ + "static/media/screenshot-5.29bb7bb2.png";